'use client';

import React, { useEffect } from 'react';
import { Box } from '@mantine/core';
import { SectionTitle } from '@/shared/SectionTitle';
import { setSelectedPage } from '@/features/menuLinks/menuLinksSlice';
import { useAppDispatch } from '@/hooks/reduxHooks';
import { SectionSubtitle } from '@/shared/SectionSubtitle';
import { SelectedPage } from '@/types/types';
import { ProductFeaturesCardsContent } from '@/types/contentTypes';
import { useInView } from 'react-intersection-observer';
import { RootBox } from '@/shared/RootBox';
import dynamic from 'next/dynamic';
import { useMediaQuery } from '@mantine/hooks';
import ProductPreview from './ProductPreview';
import ProductPreviewMobile from './ProductPreviewMobile';

export const ComingSoon = () => {
  const isOnLargeScreen = useMediaQuery('(min-width: 1060px)');

  const dispatch = useAppDispatch();
  const { ref, inView } = useInView({
    threshold: 0.2,
  });

  useEffect(() => {
    if (inView) {
      dispatch(setSelectedPage(SelectedPage.ComingSoon));
    }
  }, [inView, dispatch]);

  return (
    <Box
      className="relative z-0 w-full"
      id="comingsoon"
      ref={ref}
      style={{ overflow: 'hidden' }}
    >
      <RootBox>
        <Box className="relative flex flex-col justify-center">
          <h2 className="relative w-full text-center font-montserrat text-4xl font-bold uppercase tracking-[0.2rem] text-secondary-600 dark:text-lightBlue-200">
            Coming Soon
          </h2>
        </Box>
        <ProductPreview />
      </RootBox>
    </Box>
  );
};

ComingSoon.displayName = 'ComingSoon';
